module.exports = __webpack_public_path__ + "media/images/login/bar-f4cbf8b0e40cdfd4a97c480b90ea6c93.gif";